/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-layout row wrap class="header-container pa-0 ma-0">
    <v-layout row wrap text-xs-center>
      <v-flex
        :class="'xs12 sm12 md'+(12/(list.length >4 ? 4 : list.length) )+' lg'+(12/(list.length >4 ? 4 : list.length))+' xl'+(12/(list.length >4 ? 4 : list.length))+''"
        v-for="(item, index) in list"
        :key="index"
      >
        <v-card dark class="header-card hoverable" :class="'card-'+((index % 4)+1)">
          <v-card-text>
            <v-flex class="pa-0">
              <div class="card-value" v-if="item == 'TOTAL PLANTS'">
                <v-layout row wrap>
                  <v-flex md6 class="mx-0 px-0">{{plant_count }}</v-flex>
                  <v-flex md6 class="ma-0 px-0">
                    {{loggerData}}
                    <!-- 3/10 -->
                  </v-flex>
                </v-layout>
              </div>
              <div class="card-value" v-else-if="item == 'AC CAPACITY'">
                {{ac_capacity | value | numberWithCommas }}
                <span
                  class="card-unit"
                >{{ac_capacity | unit('ac') }}</span>
              </div>
              <div class="card-value" v-else-if="item == 'DC CAPACITY'">
                {{dc_capacity | value | numberWithCommas}}
                <span
                  class="card-unit"
                >{{dc_capacity | unit('dc') }}</span>
              </div>
              <div class="card-value" v-else-if="item == 'ENERGY TODAY'">
                {{totalGeneration | value | numberWithCommas}}
                <span
                  class="card-unit"
                >{{totalGeneration | unit('totalGen') }}</span>
              </div>
              <div class="card-value" v-else-if="item == 'CUF'">
                {{cuf | value }}
                <span class="card-unit">%</span>
              </div>
              <div class="card-value" v-else-if="item == 'PR'">
                {{getPlantTotalPr}}
                <span class="card-unit">%</span>
              </div>
              <div class="card-value home" v-else-if="item == 'Monthly PR'">
                {{monthPR}}
                <span class="card-unit">%</span>
              </div>
              <div class="card-value home" v-else-if="item == 'Annual PR'">
                {{annualPR}}
                <span class="card-unit">%</span>
              </div>
              <div class="card-value home" v-else-if="item == 'Monthly CUF'">
                {{monthCUF}}
                <span class="card-unit">%</span>
              </div>
              <div class="card-value home" v-else-if="item == 'Annual CUF'">
                {{annualCUF}}
                <span class="card-unit">%</span>
              </div>
              <div v-if="item == 'TOTAL PLANTS'" class="card-name">
                <v-layout row wrap>
                  <v-flex md6 class="px-0 pt-0">{{ $t('TOTAL PLANTS') }}</v-flex>
                  <v-flex md6 class="px-0 pt-0">{{ $t('DATA LOGGERS') }}</v-flex>
                </v-layout>
              </div>
              <div v-else-if="item != 'PR'" class="card-name">{{ $t(item) }}</div>
              <div v-else-if="item == 'PR'" class="card-name"> {{ $t('Performance Ratio') }} </div>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { mixin, mapGettersMixin } from '@/util/mixin/index'
import headerList from '../../../services/StaticInfo.js'
import headerPR from '../../../services/Home.js'
var moment = require('moment')

export default {
  mixins: [ mixin, mapGettersMixin ],
  data () {
    return {
      plant_count: 0,
      ac_capacity: 0,
      dc_capacity: 0,
      list: [],
      param: {
        plantList: []
      },
      totalGeneration: 0,
      prValue: 0,
      prName: '',
      prUnit: '',
      dlTotal: 0,
      dlWorking: 0,
      monthPR: 0,
      annualPR: 0,
      monthCUF: 0,
      annualCUF: 0,
      loggerData: ''
    }
  },
  computed: {
    ...mapGetters([
      'getAcCapacity',
      'getDcCapacity',
      'getTotalPlantCount',
      'getGeneralState',
      'getPlantTotalPr',
      'getPlantList'
    ]),
    cuf() {
      console.log('Cuf Data : ', this.getGeneralState('totalGeneration'), this.getDcCapacity)
      return (((this.getGeneralState('totalGeneration') / this.dc_capacity) / 24) * 100).toFixed(2)
    }
  },
  mounted () {
    this.ac_capacity = this.getAcCapacity
    this.dc_capacity = this.getDcCapacity
    this.plant_count = this.getTotalPlantCount
    this.getHeaderList()
    this.setIntervalWithoutDelay(this.callAllApi)
    
  },
  watch: {
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME',
      'SET_TOTAL_GENERATION'
    ]),
    async callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      await this.getHeaderData()
      await this.getTotalPRPlant()
    },
    async getHeaderList() {
      let response = await headerList.getHeaderInfo({ plantList: this.getPlantList.map(el => el.id) })
      let componentList = response.data.message
      this.list = componentList.split(',')
      this.totalGeneration = response.data.energy.todayTotalEnergy
      this.SET_TOTAL_GENERATION(this.totalGeneration)
    },
    async getHeaderData() {
      let res = await headerPR.getHeaderData({ plantList: this.getPlantList.map(el => el.id) })
      let dataLogger = res.data.message.dataLoggerRes
      let prData = res.data.message.prData
      this.loggerData = dataLogger.total_logger
      this.monthPR = prData.monthlyPR
      this.annualPR = prData.yearlyPR
      this.monthCUF = prData.monthlyCUF
      this.annualCUF = prData.yearlyCUF
    },
    async getTotalPRPlant() {
      this.prValue = this.getPlantTotalPr
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Poppins&display=swap');
.align-right {
  text-align: end;
}

.text-orange {
  color: orangered;
  -webkit-font-smoothing: antialiased;
}

.text-purple {
  color: #9866c5;
  -webkit-font-smoothing: antialiased;
}

.text-blue {
  color: #30c5ef;
  -webkit-font-smoothing: antialiased;
}

.text-green {
  color: #009688;
  -webkit-font-smoothing: antialiased;
}

.left-divider {
  border-right-width: 1px;
  border-right-style: solid;
  border-top-color: transparent;
  border-top-style: solid;
  border-top-width: 7px;
  border-bottom-color: transparent;
  border-bottom-style: solid;
  border-bottom-width: 7px;
}

.orange-divider {
  border-right-color: orangered;
}

.purple-divider {
  border-right-color: #9866c5;
}

.blue-divider {
  border-right-color: #30c5ef;
}

.green-divider {
  border-right-color: #009688;
}

.card-1{
  /* background-color: #57A2F7; */
  /* background-image: linear-gradient(to bottom right, #00d2ff, #3a7bd5); */
  background-image: linear-gradient(to bottom right, #6578E2, #6E4B9B);
}

.card-2{
  background-image: linear-gradient(to bottom right, #E86B9B, #E6866F);
}

.card-3{
  background-image: linear-gradient(to bottom right, #EEBD5A, #EFA883);
}

.card-4{
  background-image: linear-gradient(to bottom right, #22B9B5, #3AE68B);
}

.card-value{
  font-size: 30px;
  font-family: 'Poppins', sans-serif;
}

.card-unit{
  font-size: 16px;
}

.card-name {
  text-transform: uppercase;
}

.theme--dark .hoverable {
    -webkit-transition: -webkit-box-shadow .25s;
    transition: -webkit-box-shadow .25s;
    transition: box-shadow .25s;
    transition: box-shadow .25s, -webkit-box-shadow .25s;
    transition: all 0.3s ease-in-out;
}

.theme--dark .hoverable:hover {
    -webkit-box-shadow: 0 8px 17px 0 rgba(200, 200, 200, 0.25), 0 6px 20px 0 rgba(200, 200, 200, 0.25);
    box-shadow: 0 8px 17px 0 rgba(200, 200, 200, 0.25), 0 6px 20px 0 rgba(200, 200, 200, 0.25);
    transform: scale(1.1, 1.1);
    z-index: 10;
}

.theme--light .hoverable {
    -webkit-transition: -webkit-box-shadow .25s;
    transition: -webkit-box-shadow .25s;
    transition: box-shadow .25s;
    transition: box-shadow .25s, -webkit-box-shadow .25s;
    transition: all 0.3s ease-in-out;
}

.theme--light .hoverable:hover {
    -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    transform: scale(1.1, 1.1);
    z-index: 10;
}

/* [THEME] */
.theme--dark .header-card{
   border-radius: 8px;
   /* border-radius: 0px 10px 0px 8px; */
}

.theme--light .header-card{
  border-radius: 8px;
  /* border-radius: 0px 8px 8px 0px; */
}

/* Theme */

/* .theme--light .header-container {
  background-color: #ffffff;
  color: black;
}

.theme--dark .header-container {
  background-color: #1d2138;
} */

/* .theme--light .header-container {
  padding-top: 0px;
}

.theme--dark .header-container {
  padding-top: 0px;
}

@media only screen and (max-width: 750px) {
  .theme--light .header-container {
    padding-top: 25px;
  }

  .theme--dark .header-container {
    padding-top: 25px;
  }
} */

.theme--dark .left-divider {
  box-shadow: 1px 1px 5px black;
}

.theme--light .left-divider {
  box-shadow: 1px 1px 5px gray;
}

.div1 {
  flex: 1 1 auto;
  margin: 10px;
  flex-wrap: wrap;
}

.row {
  display:flex;
}
</style>
